import request from '@/utils/request'

interface OrderPageQueryParams {
  page: number;
  pageSize: number;
  status?: number | null;
  number?: string;
  phone?: string;
  beginTime?: string;
  endTime?: string;
  orderType?: 'recharge' | 'draw' | 'tip';
  excludeSpecialOrders?: boolean;
}

// 查询列表页接口
export const getOrderDetailPage = (params: OrderPageQueryParams) => {
  // 实际API调用
  return request({
    url: '/admin/order/conditionSearch',
    method: 'get',
    params
  })
}

// 查看接口
export const queryOrderDetailById = (params: { orderId: string | number }) => {
  // 实际API调用
  return request({
    url: `/admin/order/details/${params.orderId}`,
    method: 'get'
  })
}

// 查询抽奖订单的奖品信息
export const getOrderPrizeInfo = (orderNumber: string) => {
  return request({
    url: `/admin/order/prize/status/${orderNumber}`,
    method: 'get'
  })
}

// 服务接口
export const deliveryOrder = (params: { id: string | number }) => {
  return request({
    url: `/admin/order/delivery/${params.id}`,
    method: 'put'
  })
}
//完成接口
export const completeOrder = (params: { id: string | number }) => {
  return request({
    url: `/admin/order/complete/${params.id}`,
    method: 'put'
  })
}

//驳回订单接口
export const rejectOrder = (params: { id: string | number }) => {
  return request({
    url: `/admin/order/reject/${params.id}`,
    method: 'put'
  })
}

//订单取消
export const orderCancel = (params: { id: string | number }) => {
  return request({
    url: '/admin/order/cancel',
    method: 'put',
    data: { ...params }
  })
}

//接单
export const orderAccept = (params: { id: string | number }) => {
  return request({
    url: '/admin/order/confirm',
    method: 'put',
    data: { ...params }
  })
}

//拒单
export const orderReject = (params: { id: string | number }) => {
  return request({
    url: '/admin/order/rejection',
    method: 'put',
    data: { ...params }
  })
}

//分配员工
export const assignGoons = (params: { id: string | number, goonsId: string | number, goonsName: string }) => {
  return request({
    url: '/admin/order/assignGoons',
    method: 'put',
    data: { ...params }
  })
}

//获取待处理，待结单，服务中数量
export const getOrderListBy = (params: {}) => {
  console.log('调用订单统计API, 参数:', params)
  try {
    return request({
      url: '/admin/order/statistics',
      method: 'get',
      params
    }).then(response => {
      console.log('订单统计API返回数据:', response)
      return response
    }).catch(error => {
      console.error('订单统计API错误:', error)
      
      // 特别处理重复请求的情况
      if (error && error.message === '重复请求') {
        console.log('检测到重复请求，正在重试...')
        // 添加延迟后重试
        return new Promise(resolve => {
          setTimeout(() => {
            request({
              url: '/admin/order/statistics',
              method: 'get',
              params
            }).then(response => {
              console.log('订单统计API重试成功:', response)
              resolve(response)
            }).catch(retryError => {
              console.error('订单统计API重试失败:', retryError)
              resolve({
                data: {
                  code: 0,
                  msg: '重试失败',
                  data: {
                    toBeConfirmed: 0,
                    confirmed: 0,
                    deliveryInProgress: 0
                  }
                }
              })
            })
          }, 500) // 延迟500毫秒后重试
        })
      }
      
      // 返回一个默认的响应对象，避免未处理的异常
      return {
        data: {
          code: 0,
          msg: '请求失败',
          data: {
            toBeConfirmed: 0,
            confirmed: 0,
            deliveryInProgress: 0
          }
        }
      }
    })
  } catch (error) {
    console.error('订单统计API调用异常:', error)
    // 返回一个默认的Promise，避免未处理的异常
    return Promise.resolve({
      data: {
        code: 0,
        msg: '请求异常',
        data: {
          toBeConfirmed: 0,
          confirmed: 0,
          deliveryInProgress: 0
        }
      }
    })
  }
}

// 查询订单对应的奖品订单
export const getPrizeOrder = (orderNumber: string) => {
  return request({
    url: `/admin/order/prizeOrder/${orderNumber}`,
    method: 'get'
  })
}

// 发放奖品
export const deliverPrize = (orderId: string) => {
  return request({
    url: `/admin/order/prize/deliver/${orderId}`,
    method: 'put'
  })
}

// 取消发放奖品
export const cancelPrize = (orderId: string) => {
  return request({
    url: `/admin/order/cancel`,
    method: 'put',
    data: {
      id: orderId,
      cancelReason: '取消奖品发放'
    }
  })
}

// 提现申请相关接口
interface WithdrawRequestDTO {
  goonsId: number;
  amount: number;
  remark?: string;
}

interface WithdrawRequestPageQueryDTO {
  page: number;
  pageSize: number;
  goonsName?: string;
  status?: number;
  paymentMethod?: number;
  beginTime?: string;
  endTime?: string;
}

interface WithdrawRequestReviewDTO {
  id: number;
  status: 1 | 2; // 1通过 2驳回
  rejectReason?: string;
  remark?: string;
}

// 提交提现申请
export const submitWithdrawRequest = (data: WithdrawRequestDTO) => {
  return request({
    url: '/user/goons/withdraw',
    method: 'post',
    data
  })
}

// 查询打手的提现申请记录
export const getWithdrawRequestsByGoonsId = (goonsId: number) => {
  return request({
    url: `/user/goons/withdraw/list/${goonsId}`,
    method: 'get'
  })
}

// 管理员分页查询提现申请
export const getWithdrawRequestPage = (params: WithdrawRequestPageQueryDTO) => {
  return request({
    url: '/admin/withdraw/page',
    method: 'get',
    params
  })
}

// 管理员查询提现申请详情
export const getWithdrawRequestDetail = (id: number) => {
  return request({
    url: `/admin/withdraw/${id}`,
    method: 'get'
  })
}

// 管理员审核提现申请
export const reviewWithdrawRequest = (data: WithdrawRequestReviewDTO) => {
  return request({
    url: '/admin/withdraw/review',
    method: 'put',
    data
  })
}

// 管理员确认已打款
export const confirmWithdrawPayment = (id: number) => {
  return request({
    url: `/admin/withdraw/payment/${id}`,
    method: 'put'
  })
}

// 管理员获取提现申请统计信息
export const getWithdrawRequestStatistics = () => {
  return request({
    url: '/admin/withdraw/statistics',
    method: 'get'
  })
}
